<template>
  <div class="login">
    <div class="loginHead">
      <img src="../assets/images/loginLogo.png" class="loginHead-img"/>
      <span class="loginHead-title">润泽园区商户系统</span>
    </div>
    <div class="login-wrap">
      <img src="../assets/images/loginPerson.png" class="login-person"/>
      <div class="login-tip"> {{tips}}</div>
      <div v-if="loginStyle" class="login-account">
        <img src="../assets/images/loginQrcode.png" @click='changeLogin' class="login-qrcode"/>
        <el-form :label-position="formLoginPosition" label-width="0" :model="formLogin" status-icon :rules="rules"
                 ref="formLogin" class="login-form">
          <span class="login-account-login">LOGIN</span>
          <el-form-item prop="tel" class="login-form-item">
            <el-input v-model="formLogin.tel" placeholder="请输入您的手机号码" prefix-icon="el-icon-mobile-phone"></el-input>
          </el-form-item>
          <el-form-item prop="identifyCode" class="login-form-item">
            <el-input class="login-identify" v-model="formLogin.identifyCode" placeholder="请输入验证码"
                      prefix-icon="el-icon-admin-suo"></el-input>
            <el-button class="login-code" :disabled="codeDisable" @click="countDown">{{getCode}}</el-button>
          </el-form-item>
          <el-form-item class="login-form-item">
            <el-button class="form-submit" @click="submitForm('formLogin')">登录</el-button>
          </el-form-item>

        </el-form>
      </div>
      <div v-if="!loginStyle" class="login-appScan">
        <img src="../assets/images/loginMobile.png" class="login-qrcode" @click='changeLogin'/>
        <el-form :label-position="formLoginPosition" label-width="80px" :model="formLogin" status-icon :rules="rules"
                 ref="formLogin" class="login-form">
          <img src="../assets/images/qrcode.png" class="login-scanImg"/>
          <div class="login-appScan-intro">请使用登录商家账号的APP扫码登录</div>

        </el-form>
      </div>
    </div>

    <div class="login-bottom">
      <span class="loginBottom-company">加优科技提供技术支持</span>
      <div >
         <a href="http://www.miitbeian.gov.cn/publish/query/indexFirst.action" target="_blank" class="loginBottom-code">冀ICP备18015493号-1</a>
         <div style="color:#fff">/</div>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13100102000014" target="_blank" class="loginBottom-code">公安备案号 13100102000014</a>
      </div>
    </div>
  </div>
</template>

<script>
import { validatePwd, validateTel } from '@/utils/validate';
import { mainTop } from '@/api/main/index';
import { login, code, getMch, getUserInfo} from '@/api/login';
import store from '@/store';

let clock = 60

export default {
  name: '',
  props: [''],
  store,
  data () {
    const validateTelephone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('电话不能为空'))
      } else if (!validateTel(value)) {
        callback(new Error('电话输入不正确'))
      } else {
        callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (value) {
        callback()
      } else {
        callback(new Error('验证码不能为空'))
      }
    }
    return {
      loginStyle: true,
      formLoginPosition: 'left',
      formLogin: {
        tel: '',
        identifyCode: ''
      },
      rules: {
        tel: [
          {
            validator: validateTelephone,
            trigger: 'blur'
          }
        ],
        identifyCode: [
          {
            validator: validateCode,
            trigger: 'blur'
          }
        ]
      },
      tips: '请期待扫码登录',
      getCode: '获取验证码',
      codeDisable: false
    }
  },
  created () {
    this.getUserPhone()
  },
  methods: {
    getMchList () {
      let self = this
      getMch()
        .then(res => {
          let data = {
            isLogin: true,
            companyIndex: 0,
            companyList: res.data
          }
          self.$store.commit('SET_INFO', data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getUserPhone () {
      const phone = localStorage.getItem('phone') || ''
      Object.assign(this.formLogin, {tel: phone})
    },
    // 登录
    submitForm (formName) {
      let self = this
      let { tel, identifyCode } = self.formLogin
      this.$refs[formName].validate(valid => {
        if (valid) {
          login(tel, identifyCode)
            .then(res => {
              localStorage.setItem('token', res.data)
              localStorage.setItem('phone', this.formLogin.tel)
              self.$notify({
                title: '登录成功',
                type: 'success',
                duration: 800,
                showClose: false
              })
              this.getMchList()
              setTimeout(function () {
                self.$router.push({ path: '/main' })
              }, 800)
            })
            .catch(err => {
              self.$notify({
                title: '用户名验证码输入错误',
                type: 'error',
                duration: 800,
                showClose: false
              })
            })
        } else {
          return false
        }
      })
    },
    // 充值
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    // 切换登录方式
    changeLogin () {
      this.loginStyle = !this.loginStyle
      if (this.loginStyle) {
        this.tips = '扫码登录更安全';
      } else {
        this.tips = '手机登录在这里';
      }
    },
    // 倒计时
    count () {
      let self = this
      if (clock == 0) {
        let tel = self.formLogin.tel
        self.codeDisable = false
        self.getCode = '获取验证码';
        clock = 60
        //发送验证码
      } else {
        self.codeDisable = true
        self.getCode = '重新发送' + clock + 's';
        clock--
        setTimeout(function () {
          self.count()
        }, 1000)
      }
    },
    countDown () {
      let self = this
      let tel = self.formLogin.tel
      if (validateTel(tel)) {
        code(tel)
          .then(res => {
            self.$notify({
              title: '验证码已发送，请注意查看',
              type: 'success',
              duration: 800,
              showClose: false
            })
          })
          .catch(err => {
            if (err.response.status == 400) {
              self.$notify({
                title: err.response.data.msg,
                type: 'error',
                duration: 800,
                showClose: false
              })
            } else {
              self.$notify({
                title: '未知错误,请稍后再试',
                type: 'error',
                duration: 800,
                showClose: false
              })
            }
          })
          self.count()
      } else {
        self.$notify({
          title: '手机号码输入有误,请确认',
          type: 'error',
          duration: 800,
          showClose: false
        })
      }
    },
    userInfo() {
      getUserInfo().then(res => {
        console.log(res);
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../style/mixin";
@import "../style/_variables";

.login {
  @include flex-column;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  background-image: url("../assets/images/loginBg.jpg");
  background-size: 100% 100%;
  justify-content: flex-start;
  padding-top: 88px;
  > .loginHead {
    margin-bottom: 130px;
    @include flex-row;
    > .loginHead-img {
      width: 60px;
      height: 60px;
      margin-right: 8px;
    }
    .loginHead-title {
      font-size: 36px;
      font-weight: bold;
      color: #fff;
    }
  }
  > .login-wrap {
    width: $login-wrap-width;
    height: $login-wrap-height;
    background-image: url("../assets/images/loginBoxBg.png");
    background-size: 100% 100%;
    // background-color: $login-wrapbg-color;
    // border-radius: 5px;
    // box-shadow: 0 2px 10px rgba(224, 228, 11, 0.5);
    margin-right: 20px;
    position: relative;
    > .login-tip {
      position: absolute;
      right: -126px;
      top: 10px;
      width: 136px;
      height: 30px;
      background-image: url("../assets/images/loginTabBg.png");
      background-size: 100% 100%;
      color: #f7f7f7;
      @include flex-column;
      font-size: 12px;
    }
    > .login-person {
      width: 90px;
      height: 90px;
      position: absolute;
      top: -60px;
      left: 50%;
      margin-left: -45px;
    }
    > .login-account {
      width: 100%;
      height: 100%;
      @include flex-row;
      > .login-qrcode {
        position: absolute;
        width: 38px;
        height: 38px;
        right: 10px;
        top: 10px;
        cursor: pointer;
      }
      > .login-form {
        width: 336px;
        margin-top: 28px;
        // padding: 0 40px;
        @include flex-column;
        > .login-account-login {
          font-size: 20px;
          color: #fff;
          margin-bottom: 20px;
        }

        > .login-form-item {
          width: 100%;
          height: 48px;
          margin-bottom: 20px;
          position: relative;
          > .icon {
            position: absolute;
            top: 16px;
            left: 22px;
            width: 18px;
            height: 18px;
          }
          > .login-input {
            // width: 100%;
            width: 286px;
            padding: 0 0 0 50px;
            height: 100%;
            border-radius: 24px;
            border: none;
            margin-bottom: 20px;
            font-size: 16px;
            color: #767676;
          }
        }
      }
    }
    > .login-appScan {
      width: 100%;
      height: 100%;
      @include flex-row;
      > .login-qrcode {
        position: absolute;
        width: 38px;
        height: 38px;
        right: 10px;
        top: 10px;
        cursor: pointer;
      }
      > .login-form {
        @include flex-column;
        margin-top: 20px;
        > .login-scanImg {
          width: 180px;
          height: 180px;
        }
        > .login-appScan-intro {
          margin-top: 20px;
          color: #f7f7f7;
          font-size: 16px;
        }
      }
    }
  }
     > .login-bottom {
          position: absolute;
      bottom: 10px;
      width: 100%;
      @include flex-column;
      > .loginBottom-company {
        font-size: 14px;
        color: #f7f7f7;
      }
      >div{
        >a{
          font-size: 12px;
          color: #f7f7f7;
        }
        
        display: flex;
      }
    }
}

// 修改输入框样式
.login-identify {
  width: 198px !important;

  > .el-input {
    border-radius: 40px;
  }
}

.login-code {
  width: 120px;
  background-color: #fff;
  color: #32d08a;
  padding: 14px 20px;
  border-radius: 24px;
  font-size: 14px;
  box-shadow: 1px 1px #474747;
  margin-left: 10px;
  cursor: pointer;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #c0c4cc;
}

.form-submit {
  width: 100%;
  background-color: #32d08a;
  height: 48px;
  color: #fffefe;
  font-size: 16px;
  border-radius: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue